export class DPContentConfig {
    public static products = [
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
        {
            img: 'discount.png',
            title: 'superstay matte ink',
            discount: 90,
        },
    ]
}